import { useSnackbar } from 'notistack'
import React, { memo, useCallback } from 'react'
import { connect } from 'react-redux'

import { anularFinLlenado } from '../../../../../../../../models/movimiento/movimientoService'
import { closeDialog } from '../../../../../../../Forms/SharedComponents/containers/Dialog/actions/dialogActions'
import { actualizarEstadoSilos } from '../../../../../../actions'
import { OperacionEliminarFinDeLlenadoView } from '../components/OperacionEliminarFinDeLlenadoView'

export const OperacionEliminarFinDeLlenado = connect(null, { closeDialog, actualizarEstadoSilos })(
  memo(({ silo, closeDialog, actualizarEstadoSilos }) => {
    const { enqueueSnackbar } = useSnackbar()
    return (
      <OperacionEliminarFinDeLlenadoView
        silo={silo}
        aceptar={async () => {
          try {
            await anularFinLlenado(silo)
            closeDialog()
            enqueueSnackbar('Anulado de fin correcto')
            actualizarEstadoSilos()
          } catch (error) {
            enqueueSnackbar('Anulado de fin incorrecto', { variant: 'error' })
          }
        }}
        cancelar={useCallback(() => {
          closeDialog('ANULAR_FIN_LLENADO_SILO')
        }, [closeDialog])}
      />
    )
  })
)
